import {
  TButtonTranslations,
} from './npm-controller-menu.ts';

const buttonTranslations: TButtonTranslations = {
  LOAD_JOB: {
    label: 'Charge laden',
    confirmMessage: '',
    confirmLabel: '',
  },
  START_JOB: {
    label: 'Charge starten',
    confirmMessage: 'Bitte bestätige den Start von {recipeCode} auf {assetDisplayName}.',
    confirmLabel: '{recipeCode} starten',
  },
  ABORT_JOB: {
    label: 'Charge abbrechen',
    confirmMessage: 'Soll {jobNo} ({recipeCode}) in {assetDisplayName} wirklich abgebrochen werden?',
    confirmLabel: '{jobNo} abbrechen',
  },
  RESUME_JOB: {
    label: 'Charge fortführen',
    confirmMessage: 'Soll {recipeCode} in {assetDisplayName} forgeführt werden?',
    confirmLabel: '{recipeCode} fortführen',
  },
};

export default {
  button: buttonTranslations,
};
